import React from "react";

export default theme => ({
	appBar: {
		display: "flex",
		backgroundColor: theme.palette.background.default,
		transition: theme.transitions.create(["width", "margin"], {
			duration: theme.transitions.duration.leavingScreen,
			easing: theme.transitions.easing.sharp
		}),
		zIndex: theme.zIndex.drawer + 1
	},
	mediaIcons: {
		position: "absolute",
		top: 10,
		right: theme.spacing.unit * 2,
		display: "flex",
		fontWeight: 900,
		zIndex: 2
	},
	icon: {
		cursor: "pointer",
		"& path": {
			fill: theme.palette.primary.dark
		},
		width: "36px",
		height: "36px",
		marginRight: "6px",
		marginTop: "6px",
		"&:hover path": {
			fill: theme.palette.secondary.main
		}
	},
	officeVersionVideo: {
		width: "100%"
	},
	video: {
		width: "100%",
		height: "100%",
		maxWidth: 1024,
		margin: "auto",
		cursor: "pointer"
	},
	underHeaderLine: {
		borderTopWidth: 4,
		borderColor: theme.palette.primary.main,
		borderStyle: "solid"
	},
	filters: {},
	mediaSlideShow: {
		top: 0,
		left: 0,
		right: 0,
		width: "100vw",
		bottom: 0,
		height: "100vh",
		zIndex: 1205,
		position: "fixed",
		background: "rgba(0,0,0,.7)",
		alignItems: "center",
		display: "flex",
		"& .image-gallery": {
			width: "100%",
			marginTop: "24px",
			"& :focus": {
				outline: "none"
			}
		},
		"& h6": {
			top: "5px",
			position: "absolute",
			marginLeft: "auto",
			marginRight: "auto",
			left: 0,
			right: 0,
			textAlign: "center",
			fontSize: "30px",
			margin: 0,
			textTransform: "capitalize"
		}
	},
	backActions: {
		position: "absolute",
		top: 10,
		right: theme.spacing.unit * 2,
		display: "flex",
		fontWeight: 900,
		zIndex: 2,
		"& span": {
			cursor: "pointer"
		}
	},
	closeSlideShowBtn: {
		position: "absolute",
		top: 0,
		right: "26px",
		color: "#fff"
	},
	advancedSearch: {
		position: "absolute",
		right: 0,
		marginRight: theme.spacing.unit * 5,
		display: "flex",
		alignItems: "center"
	},
	btnOpenSidebar: {
		transform: "rotate(0deg)",
		transition: "transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
	},
	advancedSearchOpened: {
		transform: "rotate(45deg)"
		// backgroundColor: theme.palette.primary.dark
	},
	advancedMediaOpened: {
		transform: "rotate(45deg)"
		// backgroundColor: theme.palette.primary.dark
	},
	logo: {
		width: 123
	},
	filter: {
		display: "inline-flex",
		alignItems: "center",
		marginRight: theme.spacing.unit * 3,
		"&:last-child": {
			margin: 0
		}
	},
	office: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	root: {
		display: "flex"
	},
	title: {
		marginRight: theme.spacing.unit * 3
	},
	toolbar: {
		...theme.mixins.toolbar,
		alignItems: "center"
	},
	btn: {
		width: 30,
		height: 30,
		"@media (min-width:960px) and (max-width:1440px)": {
			width: 24,
			height: 24
		},
		"& svg": {
			"@media (min-width:960px) and (max-width:1440px)": {
				width: 18,
				height: 18
			}
		}
	},
	[theme.breakpoints.down("md")]: {
		filter: {
			marginRight: theme.spacing.unit
		},
		toolbar: {
			padding: theme.spacing.unit
		},
		advancedSearch: {
			marginRight: theme.spacing.unit
		},
		title: {
			marginRight: theme.spacing.unit
		}
	},
	[theme.breakpoints.down("sm")]: {
		mediaIcons: {
			position: "relative",
		},
	},
});
